import { useHasUserTag } from '@centra/centra-ui'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAgencyAction, getClientCompanyAction } from 'store/authentication/actions'

export const useClient = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }))

  const isAgency = useHasUserTag(['role.agency-manager', 'role.agency-primary-manager'])

  useEffect(() => {
    if (isAgency) {
      dispatch(getAgencyAction())
    } else if (user?.clientId) {
      dispatch(getClientCompanyAction({ clientCompanyId: user.clientId }))
    }
  }, [isAgency, user])

  return {
    isAgency,
  }
}
